<template>
    <div class="container-fluid">
        <div class="row">
            <Condimentlist />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const Condimentlist = defineAsyncComponent(() => import("@/components/theme/ecommerce/condimentadd/Condimentlist.vue"))
</script>